<template>
  <v-dialog v-model="DisplayDialog" :persistent="persistent" :fullscreen="expanded || isPhoneBool" :height="customHeight"
    :width="customWidth">
    <v-card>

      <slot name="header">
        <dialog-header v-model="expanded" :title="title" @Close="DisplayDialog = false">
        </dialog-header>
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
      </slot>

      <div class="pa-0 pb-13" id="managedoverflow" :style="'max-height:' + computedContentHeight + 'px'">
        <slot name="content">
          No content
        </slot>
      </div>

      <slot name="bottom" :resize="onresize">
        <dialog-bottom @resize="onresize" @Close="DisplayDialog = false">
          <template v-slot:buttons>
            <slot name="buttons" />
          </template>
        </dialog-bottom>
      </slot>
    </v-card>
  </v-dialog>
</template>


<script>
import DialogHeader from "@/components/Dialogs/Dialog parts/DialogHeader.vue";
import DialogBottom from "@/components/Dialogs/Dialog parts/DialogBottom.vue";

export default {
  name: "SlottedDialog",
  props: ["externaltrigger", "externalCloseTrigger", "title", "persistent", "dialog", "loading"],
  components: { DialogHeader, DialogBottom },

  data: () => ({
    expanded: false,
    DisplayDialog: false,
    customWidth: 550,
    customHeight: 800,
    customMinimumsWidth: 300,
    customMaximumsWidth: 1000,
    customWidthOffset: 0,
  }),

  methods: {
    onresize(offsetX, offsetY) {
      this.customWidth = Math.min(
        this.customMaximumsWidth,
        Math.max(this.customWidth + offsetX * 2, this.customMinimumsWidth)
      );
      this.customHeight = this.customHeight + offsetY * 2;
    },
    hideChat() {
      if (this.isPhoneBool) {
        setTimeout(() => document.getElementById("chatcontainer").classList.add("hide"), 180);
      }
    },
    showChat() {
      document.getElementById("chatcontainer").classList.remove("hide");
    },
  },

  computed: {
    computedContentHeight() {
      return this.ClientHeight - 56;
    },
  },

  watch: {
    DisplayDialog: function (val) {
      if (!val) this.$emit("close");
    },
    externaltrigger: function () {
      this.hideChat();
      this.DisplayDialog = true;
    },
    externalCloseTrigger: function () {
      this.showChat();
      this.DisplayDialog = false;
    },
    "$vuetify.breakpoint.width"() {
      if (this.isPhoneBool) {
        this.hideChat();
      } else {
        this.showChat();
      }
    },
  },

  beforeDestroy() {
    this.showChat();
    this.DisplayDialog = false;
  },
};
</script>

<style lang="scss">
#managedoverflow {
  overflow-y: auto;
  height: auto;
}

@media only screen and (min-width: 601px) {
  #managedoverflow {
    max-height: 70vh !important;
  }
}

#gradientbackground {
  background-color: rgba(249, 249, 249, 0.823) !important;
  position: absolute;
  bottom: 0;
  z-index: 10;
}

/*
@media only screen and (max-width: 600px) {
  #managedoverflow {
    max-height: 100vh;
    height: calc(100vh - 56px);
  }
}
*/
</style>